// @mui
import { Box, Button, Stack, Typography } from '@mui/material';
import NextLink from "next/link";
import NextSanityImage from 'src/components/NextSanityImage';
// @types
import { AdvertisementProps } from '../../@types/advertisement';
// components
import { BgOverlay } from '../../components';

// ----------------------------------------------------------------------

type Props = {
  advertisement: AdvertisementProps;
};

export default function Advertisement01({ advertisement }: Props) {
  const { title, description, path, cta, imageUrl } = advertisement;

  return (
    <Box sx={{ position: 'relative', borderRadius: 2, overflow: 'hidden' }}>
      <Stack
        alignItems="center"
        sx={{
          p: 5,
          width: 1,
          bottom: 0,
          zIndex: 9,
          textAlign: 'center',
          position: 'absolute',
        }}
      >
        <Typography variant="h4" sx={{ color: 'secondary.main' }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ mt: 1, mb: 3, color: 'common.white' }}>
          {description}
        </Typography>
        <NextLink href={path} passHref>
          <Button variant="contained">
            {cta ? cta : 'Se mer'}
          </Button>
        </NextLink>

      </Stack>

      <NextSanityImage alt="advertisement" src={imageUrl} ratio="1/1" />

      <BgOverlay />
    </Box>
  );
}
